<script>
  import { fade, scale } from "svelte/transition";
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let show = false;
  export let onClose = () => {};
  export let disableOverlayClose = false;
  export let title;
  export let width;
  export let primaryButtonDisabled = false;

  function handleOverlayClick() {
    if (!disableOverlayClose) {
      onClose();
    }
  }
</script>

{#if show}
  <div class="overlay" on:click={handleOverlayClick} transition:fade>
    <div
      class="modal"
      on:click|stopPropagation
      transition:scale
      style={width ? `width: ${width}px;` : undefined}
    >
      <div class="modal-header">
        <span class="modal-title">{title}</span>
        <div class="close-btn" on:click={onClose} aria-label="닫기">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
          >
            <path
              d="M10.9661 0.10965C11.2248 -0.0612335 11.5768 -0.0322291 11.8046 0.195587C12.0324 0.423402 12.0614 0.77535 11.8905 1.03412L11.8046 1.13828L6.94266 6.00021L11.8046 10.8621L11.8905 10.9663C12.0614 11.2251 12.0324 11.577 11.8046 11.8048C11.5768 12.0326 11.2248 12.0616 10.9661 11.8908L10.8619 11.8048L5.99996 6.9429L1.13804 11.8048C0.877693 12.0652 0.455689 12.0652 0.195342 11.8048C-0.065004 11.5445 -0.0650041 11.1225 0.195342 10.8621L5.05727 6.00021L0.195342 1.13828L0.109406 1.03412C-0.0614776 0.77535 -0.0324732 0.423402 0.195342 0.195587C0.423158 -0.0322291 0.775106 -0.0612335 1.03387 0.10965L1.13804 0.195587L5.99996 5.05751L10.8619 0.195587L10.9661 0.10965Z"
              fill="#1D2226"
            />
          </svg>
        </div>
      </div>
      <div class="modal-content">
        <slot></slot>
      </div>
      <div class="modal-footer">
        <slot name="footer">
          <button
            class="confirm-btn"
            disabled={primaryButtonDisabled}
            on:click={() => dispatch("submit")}>확인</button
          >
        </slot>
      </div>
    </div>
  </div>
{/if}

<style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }
  .modal {
    background: #fff;
    min-width: 400px;
    max-width: 95vw;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.13);
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }
  .modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 16px;
    border-bottom: 1px solid #e5e5e5;
    background: #f0f3f9;
    height: 48px;
  }
  .modal-title {
    font-size: 14px;
    font-weight: 500;
    color: #1d2226;
    letter-spacing: 0.1px;
  }
  .close-btn {
    background: none;
    border: none;
    font-size: 22px;
    color: #888;
    cursor: pointer;
    padding: 0 4px;
    line-height: 1;
  }
  .modal-content {
    padding: 20px;
    flex: 1 1 auto;
    background: #fff;
    max-height: 700px;
    overflow: auto;
  }
  .category-title {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #444;
  }
  .category-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .category-item {
    display: flex;
    align-items: center;
    padding: 12px 0 12px 0;
    font-size: 15px;
    color: #222;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.15s;
  }
  .category-item:hover {
    background: #f5f7fa;
  }
  .category-icon {
    font-size: 18px;
    margin-right: 10px;
    color: #7b7b7b;
  }
  .category-add {
    display: flex;
    align-items: center;
    padding: 14px 0 14px 0;
    font-size: 15px;
    color: #888;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    transition: background 0.15s;
  }
  .category-add:hover {
    background: #f5f7fa;
    color: #222;
  }
  .add-icon {
    font-size: 18px;
    margin-right: 10px;
    color: #b0b0b0;
  }
  .modal-footer {
    padding: 12px 20px 12px 20px;
    background: #f0f3f9;
    border-top: 1px solid #e5e5e5;
    display: flex;
    justify-content: flex-end;
    height: 54px;
  }
  .confirm-btn {
    background: #3b5998;
    color: #fff;
    border-radius: 2px;
    padding: 0px 24px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
  }
  .confirm-btn:hover {
    background: #1b3e8a;
  }
  .confirm-btn:disabled {
    background: #bfc8d7;
    color: #fff;
    cursor: not-allowed;
    opacity: 0.7;
  }
</style>
